<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
      <div class="invoice_heading mb_15" style="display: flex; justify-content: space-between">
        <h3>Invoice Details</h3>

        <router-link v-if="refFrom && refFrom === 'billings'" :to="{name: 'billing_index'}" class="btn btn_black">Back to List</router-link>
        <router-link v-else :to="{name: 'view_customer_billing', params: {id: customer_id}}" class="btn btn_black">Back to List</router-link>

      </div>
      <div class="row">
        <div class="col_12">
          <div class="vc_billing_invoice">
            <div class="row">
              <div class="col_6">
                <div class="card">
                  <div class="card-body">
                    <h5 class="common_subtitle pb_15 border-lightgray-bottom mb_0">
                      {{ invoice.month_name }} Summary <br> <span class="font_12p fw_normal">{{ $moment(invoice.from_date).format('Y-M-D') }} - {{ $moment(invoice.to_date).format('Y-M-D') }}</span>
                    </h5>
                    <table class="common_table table w-100 border_none table_no_hover">
                      <tbody>
                      <tr>
                        <td class="border_none fw_bold">Total</td>
                        <td class="text_right border_none"><span class="font_22p  fw_bold">￦{{ totalAmount.toLocaleString() }}</span></td>
                      </tr>
                      <tr>
                        <td colspan="2" class="border_none">
                          <div class="d_flex_start">
                            Monthly change
                            <span class="color_danger ml_5 mr_5">
                              <i v-if="currentMonthlyChange < 0" class="lni lni-arrow-down"></i>
                              <i v-if="currentMonthlyChange > 0" class="lni lni-arrow-up"></i>
                            </span> {{ currentMonthlyChange }}
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div class="additional_service_table">
                      <div class="row">
                        <div class="col_6 pr_20">
                          <table class="common_table table w-100  table_no_hover mb_0">
                            <tbody>
                            <tr>
                              <td>Additional Service Fee</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col_6 pl_20">
                          <table class="common_table table w-100  table_no_hover mb_0">
                            <tbody>
                            <tr>
                              <td>Cloud Service Charge</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            <tr>
                              <td>Support Fee</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            <tr>
                              <td>Ncloud Discount</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            <tr>
                              <td>Sales Discount</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            <tr>
                              <td>Credit</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            <tr>
                              <td colspan="2" class="text_right font_18p fw_bold">
                                ￦{{ totalAmount.toLocaleString() }}
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col_6">
                <div v-if="previousInvoice && previousInvoice?.from_date" class="card">
                  <div class="card-body">
                    <h5 class="common_subtitle pb_15 border-lightgray-bottom mb_0">
                      {{ previousInvoice.month_name }} Summary <br>
                      <span class="font_12p fw_normal">{{ previousInvoice.from_date }} - {{ previousInvoice.to_date }}</span>
                    </h5>
                    <table class="common_table table w-100 border_none table_no_hover">
                      <tbody>
                      <tr>
                        <td class="border_none fw_bold">Total</td>
                        <td class="text_right border_none">
                          <span class="font_22p color_primary fw_bold">
                          {{ previousInvoice.formatted_total_amount }}
                        </span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" class="border_none">
                          <div class="d_flex_start">
                            Monthly change
                            <span class="color_danger ml_5 mr_5">
                              <i v-if="previousMonthlyChange < 0" class="lni lni-arrow-down"></i>
                              <i v-if="previousMonthlyChange > 0" class="lni lni-arrow-up"></i>
                            </span>
                            {{ previousMonthlyChange }}
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div class="additional_service_table">
                      <div class="row">
                        <div class="col_6 pr_20">
                          <table class="common_table table w-100  table_no_hover mb_0">
                            <tbody>
                            <tr>
                              <td>Additional Service Fee</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col_6 pl_20">
                          <table class="common_table table w-100  table_no_hover mb_0">
                            <tbody>
                            <tr>
                              <td>Cloud Service Charge</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            <tr>
                              <td>Support Fee</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            <tr>
                              <td>Ncloud Discount</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            <tr>
                              <td>Sales Discount</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            <tr>
                              <td>Credit</td>
                              <td class="text_right">￦0</td>
                            </tr>
                            <tr>
                              <td colspan="2" class="text_right font_18p fw_bold">
                                {{ previousInvoice.formatted_total_amount }}
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col_12">
                <h5 class="common_subtitle pb_15 pt_20 mb_0"> Services </h5>
              </div>
            </div>
            <div class="row mb_20">
              <div class="col_12">
                <table class="common_table table table_bordered table_no_hover w-100">
                  <thead>
                  <tr>
                    <th>Name</th>
                    <th>Provider</th>
                    <th>Service Type</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Billing Month</th>
                    <th>Status</th>
                    <th>Total</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="bill in bills" :key="'bill_id_' + bill.id">
                    <td>
                      <template v-if="bill?.cloudServerPrice?.cloud_disk_id">
                        {{ bill?.cloudServerPrice?.cloud_disk?.name }}
                      </template>
                      <template v-if="bill?.cloudServerPrice?.cloud_network_id">
                        {{ bill?.cloudServerPrice?.cloud_network?.public_ip }}
                      </template>
                      <template v-if="bill?.cloudServerPrice?.cloud_server_id">
                        {{ bill?.cloudServerPrice?.cloud_server?.host_name }}
                      </template>
                    </td>
                    <td>{{ bill?.cloud_service?.name }}</td>
                    <td>{{ bill?.service_type }}</td>
                    <td>{{ $moment(bill.from_date).format('ddd MMM DD YYYY HH:mm:ss') }}</td>
                    <td>{{ $moment(bill.to_date).format('ddd MMM DD YYYY HH:mm:ss') }}</td>
                    <td>{{ bill.billing_date }}</td>
                    <td>{{ bill.status }}</td>
                    <td>{{ bill.formatted_amount }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";

    export default {
        name: 'CustomerBillView',
        components: { LoaderMaskComponent },
        data(){
            return {
              lyLoading: false,
              id: this.$route.params.id,
              date: this.$route.params.date,
              customer_id: this.$route.params.customer_id,
              contact: null,
              activeTab: 'activityList',
              billings: [],
              tickets: [],
              invoices: [],
              bills: [],
              invoice: '',
              previousInvoice: null,
              refFrom: this.$route.query.ref_from
            }
        },
        watch: {
            $route(to, from) {
                if(to.name == from.name && !window._.isEqual(to, from)){
                    this.loadContactData()
                    this.loadTimelineData()
                }
            },
        },
      computed:{
        currentMonthlyChange() {
          if (this.previousInvoice && this.totalAmount) {
            const previousAmount = this.previousInvoice.total_amount;
            const currentAmount = this.totalAmount;

            if (previousAmount > 0) {
              const percentageChange = (currentAmount - previousAmount);
              return percentageChange;
            }
          }
          return null;
        },
        previousMonthlyChange() {
          if (this.previousInvoice && this.totalAmount) {
            const previousAmount = this.previousInvoice.total_amount;
            const currentAmount = this.totalAmount;

            if (previousAmount > 0) {
              const percentageChange = (previousAmount - currentAmount);
              return percentageChange;
            }
          }
          return null;
        },
        totalAmount() {
          if (this.bills?.length) {
            return this.bills.reduce((sum, bill) => sum + bill.amount, 0);
          }
          return 0;
        }
      },
        created() {
            if(this.$route.params.id){
              this.getInvoiceDetails()
              this.previousMonthBillInvoice()
              this.billingInvoiceServices()
            }
        },
        mounted(){
          this.ticketScrollbar()
        },
        methods: {
          getInvoiceDetails() {
            this.axios.get(`/generated-payments/${this.customer_id}/${this.id}/${this.date}`)
                .then(({data}) => {
                  this.invoice = data.data
                })
          },
          previousMonthBillInvoice() {
            this.axios.get(`/previous-month-generated-payment/${this.customer_id}/${this.date}`)
                .then(({data}) => {
                  this.previousInvoice = data
                })
          },
          billingInvoiceServices() {
            this.axios.get(`/billing-invoice-services/${this.customer_id}/${this.date}`)
                .then(({data}) => {
                  this.bills = data.data
                })
          }
        }
    }
</script>
<style scoped>

</style>
